import { PROCESSING_MESSAGE } from 'config/constants';
import ProcessingRequest from 'components/ProcessingRequest';

const { HEADER, INFO_TEXT, INFO_TEXT_AFTER_10_SECS } = PROCESSING_MESSAGE.CANCELLATION;

const ProcessingCancellation = () => <ProcessingRequest header={HEADER} info={INFO_TEXT} infoAfter10Sec={INFO_TEXT_AFTER_10_SECS} />;

export default ProcessingCancellation;
